// @flow
import React, { Component } from "react";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Button from "@material-ui/core/Button";
import ButtonBase from "@material-ui/core/ButtonBase";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import { CancelButton } from "imagus-components";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    paddingBottom: "10px"
  },
  image: {
    position: "relative",
    width: "100%",
    height: "100%",
    "&:hover, &$focusVisible": {
      zIndex: 1,
      "& $imageBackdrop": {
        opacity: 0.15
      }
    }
  },
  focusVisible: {},
  imageSrc: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center 40%"
  },
  imageBackdrop: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create("opacity")
  }
});

type SampleImagesClassesType = {
  root: DictionaryType,
  image: DictionaryType,
  focusVisible: DictionaryType,
  imageSrc: DictionaryType,
  imageBackdrop: DictionaryType
};

type SampleImagesPropsType = {
  classes: SampleImagesClassesType,
  cancelSamples: Function,
  loadSample: Function,
  samples: Array<string>
};

class SampleImages extends Component<SampleImagesPropsType, *> {
  render(): * {
    const classes = this.props.classes;

    return (
      <div>
        <GridList
          cellHeight={160}
          cols={4}
          spacing={16}
          className={classes.root}
        >
          {this.props.samples.map((sample: *, i: number): * => (
            <GridListTile key={i} cols={1}>
              <ButtonBase
                focusRipple
                className={classes.image}
                focusVisibleClassName={classes.focusVisible}
                onClick={(): * => this.props.loadSample(sample)}
              >
                <span
                  className={classes.imageSrc}
                  style={{
                    backgroundImage: `url(${sample})`
                  }}
                />
                <span className={classes.imageBackdrop} />
              </ButtonBase>
            </GridListTile>
          ))}
        </GridList>
        <CancelButton onClick={this.props.cancelSamples} />
      </div>
    );
  }
}

export default withStyles(styles)(SampleImages);
